module.exports = __webpack_public_path__ + "img/stewards.96b71466.png";